module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@2x-8c436dcd65d18d435cc7c3bad0b59816.png";